import React, { useContext } from 'react';
import { Tooltip, Button, Icon } from 'components';
import { useBreakpoint } from 'hooks';
import MyBrokerageContext from './MyBrokerageContext';
import { JoinedSearchOptions } from './types';

type LockButtonProps = {
  searchOptions: JoinedSearchOptions;
};

const LockButton: React.FC<LockButtonProps> = ({ searchOptions }) => {
  const { md } = useBreakpoint();
  const { filtersLocked, setLockedSearchOptions } =
    useContext(MyBrokerageContext);

  const handleClick = () => {
    if (filtersLocked) setLockedSearchOptions(null);
    else setLockedSearchOptions(searchOptions);
  };

  if (!md) {
    return (
      <Button data-cy="lock-button" onClick={handleClick}>
        {filtersLocked ? 'Unlock Filters' : 'Lock Filters'}
      </Button>
    );
  }

  return (
    <Tooltip title={filtersLocked ? 'Unlock Filters' : 'Lock Filters'}>
      <Button
        data-cy="lock-button"
        type={filtersLocked ? 'primary' : undefined}
        icon={
          <Icon
            type="antdUnlockFilled"
            width={12}
            color={filtersLocked ? 'white' : undefined}
          />
        }
        onClick={handleClick}
      />
    </Tooltip>
  );
};

export default LockButton;
